@switch (columnName) {
  @case ('readableId') {
    @if (showAlertWarnings) {
      <mat-icon
        class="status-icon"
        [class.expired]="element.alertStatus === alertStatus.Expired"
        [class.expiring]="element.alertStatus === alertStatus.Expiring"
      >
        circle
      </mat-icon>
    }
    {{ element.readableId }}
  }
  @case ('subtaskName') {
    @if (showSubtaskWarnings) {
      <mat-icon
        class="status-icon"
        [class.expired]="element.alertStatus === alertStatus.Expired"
        [class.expiring]="element.alertStatus === alertStatus.Expiring"
      >
        circle
      </mat-icon>
    }
    {{ element.name }}
  }
  @case ('name') {
    @if (showStatusDotInName) {
      <mat-icon
        class="status-icon"
        [class.expired]="element.alertStatus === alertStatus.Expired"
        [class.expiring]="element.alertStatus === alertStatus.Expiring"
      >
        circle
      </mat-icon>
    }
    {{ element.name }}
  }
  @case ('nonConformanceId') {
    {{ element.readableId }}
  }
  @case ('severity') {
    {{ element.severity?.name || '-' }}
  }
  @case ('type') {
    {{ element.type.name }}
  }
  @case ('nonConformanceDate') {
    {{ element.nonConformanceDate | date }}
  }
  @case ('expires') {
    {{ element.expires | date }}
  }
  @case ('dueDate') {
    {{ element.dueDate | date }}
  }
  @case ('created') {
    {{ element.created | date: dateTimeFormat }}
  }
  @case ('createdBy') {
    {{ element.createdBy | fullName }}
  }
  @case ('status') {
    <app-ui-pill [name]="subtaskStatusLabels[element.status]"></app-ui-pill>
  }
  @case ('version') {
    V{{ element.formVersion }}
  }
  @case ('dateTime') {
    @if (element.action === 'Legacy' && element.created) {
      {{ element.created | date: dateTimeFormat }}
    } @else {
      {{ element.updated ? (element.updated | date: dateTimeFormat) : '-' }}
    }
  }
  @case ('editedBy') {
    {{ element.updatedBy | fullName }}
  }
  @case ('action') {
    {{ element.action | mapNonConformanceAction | translate }}
  }
  @case ('restore') {
    <app-ui-button
      (click)="restore(); $event.stopPropagation()"
      buttonType="secondary"
      text="{{ 'restore' | translate }}"
      [privilege]="Privileges.NonConformanceRestore"
    ></app-ui-button>
  }
  @case ('comment') {
    {{ 'comment' | translate }}: {{ element.comment }}
  }
  @case ('actionButton') {
    @if (
      element.action === nonConformanceAction.ReportUpdated ||
      element.action === nonConformanceAction.ReportCreated
    ) {
      @if (element.responseId) {
        <app-ui-button
          buttonType="icon-button"
          icon="remove_red_eye"
          [ariaLabel]="'view' | translate"
          (click)="viewPreviousReport(element.id, element.responseId)"
        ></app-ui-button>
      }
    }
    @if (element.action === nonConformanceAction.Legacy) {
      @if (element.id !== 'new' && element.link?.length > 1) {
        <a [href]="element.link" target="_blank" [download]="element.name">
          <mat-icon class="download-icon">download</mat-icon>
        </a>
      }
    }
  }
  @case ('severities') {
    @for (severity of element.severities; track $index) {
      <div>
        {{ severity?.name ?? '-' }}
      </div>
    }
  }
  @case ('nonConformanceTypes') {
    @for (type of element.nonConformanceTypes; track $index) {
      <div>
        {{ type?.name ?? '-' }}
      </div>
    }
  }
  @case ('responsibleForClosing') {
    @for (position of element.positionsResponsibleForClosing; track $index) {
      <div>
        {{ position.name }}
      </div>
    }
    @for (positionGroup of element.positionGroupsResponsibleForClosing; track $index) {
      <div>
        {{ positionGroup.name }}
      </div>
    }
    @for (role of element.rolesResponsibleForClosing; track $index) {
      <div>
        {{ role.name }}
      </div>
    }
    @for (user of element.usersResponsibleForClosing; track $index) {
      <div>
        {{ user | fullName }}
      </div>
    }
  }
  @case ('responsibleForFollowUp') {
    @for (positionForFollowUp of element.positionsResponsibleForFollowUp; track $index) {
      <div>
        {{ positionForFollowUp.name }}
      </div>
    }
    @for (positionGroupForFollowUp of element.positionGroupsResponsibleForFollowUp; track $index) {
      <div>
        {{ positionGroupForFollowUp.name }}
      </div>
    }
    @for (role of element.rolesResponsibleForFollowUp; track $index) {
      <div>
        {{ role.name }}
      </div>
    }
    @for (userForFollowUp of element.usersResponsibleForFollowUp; track $index) {
      <div>
        {{ userForFollowUp | fullName }}
      </div>
    }
  }
  <!-- responsible for NC subtask -->
  @case ('responsible') {
    @for (position of element.responsibleForPositions; track $index) {
      <div>
        {{ position.name }}
      </div>
    }
    @for (positionGroup of element.responsibleForPositionGroups; track $index) {
      <div>
        {{ positionGroup.name }}
      </div>
    }
    @for (role of element.responsibleForRoles; track $index) {
      <div>
        {{ role.name }}
      </div>
    }
    @for (user of element.responsibleForUsers; track $index) {
      <div>
        {{ user.name }}
      </div>
    }
  }
  @case ('subtaskAction') {
    {{ subtaskActionLabels[element.subtaskAction] | translate }}
  }
  @case ('department') {
    {{ element.department.name }}
  }
  @case ('subtaskComments') {
    <div class="comments-count" (click)="showSubtaskComments(); $event.stopPropagation()">
      <mat-icon>comment</mat-icon>
      <span class="ml-05">{{ element.commentCount || 0 }}</span>
    </div>
  }
  @default {
    {{ element[columnName] }}
  }
}
